import { createReducer, createSetter } from "@/redux/helpers/reducer";

import * as actions from "./attachments.actions";

const initialState = {
  attachments: [],
  selectedAttachments: [],
  isFetching: false,
};

export default createReducer(initialState, {
  [actions.setAttachments]: createSetter("attachments"),
  [actions.setSelectedAttachments]: createSetter("selectedAttachments"),
  [actions.setIsFetching]: createSetter("isFetching"),
  [actions.reset]: () => ({ ...initialState }),
});
